import { render, staticRenderFns } from "./RingCentral.vue?vue&type=template&id=32df3f94&scoped=true&"
import script from "./RingCentral.vue?vue&type=script&lang=js&"
export * from "./RingCentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df3f94",
  null
  
)

export default component.exports